import { useCallback } from "react";

import { useObjectMemo } from "../../../hooks";
import { useRequestWithFeedback } from "../../../composites";
import { REQUEST_STATUS } from "../../../composites/request/request.types";
import { useAppDispatch } from "../utils";

import { API } from "./api";
import { actions } from "./slice";
import { useHolidays } from "./hooks";

import type { BootstrapFetchRequest } from "../../bootstrap";

export const useFetchHolidays = () => {
  const { send, status } = useRequestWithFeedback<
    API.FetchHolidays.Response,
    API.FetchHolidays.Error
  >();

  const dispatch = useAppDispatch();
  const fetchHolidays = useCallback(() => {
    send({
      action: API.fetchHolidays(),
      onData: ({ holidays }) => {
        // normalize to "yyyy-MM-dd" date strings for business-day math
        dispatch(
          actions.setAll(
            holidays.map(
              (holiday) => holiday.start_time.substring(0, 10) as DateString,
            ),
          ),
        );
      },
    });
  }, [dispatch, send]);

  const hasData = useHolidays().length > 0;

  return useObjectMemo({
    error: status === REQUEST_STATUS.error,
    send: fetchHolidays,
    loading:
      status === REQUEST_STATUS.idle || status === REQUEST_STATUS.loading,
    hasData,
  }) satisfies BootstrapFetchRequest;
};
